module.exports = __webpack_public_path__ + "img/Butterfly_00121.0d73ea1a.png";